<template>
    <div style="padding:50px 0px;">
        <div class="tab-pane pt-3 active show" v-if="!isLoading">
            <section class="row" :class="{'section-loading': isLoading}">
                <table class="table datatable">
                    <thead>
                        <tr>
                            <th style="width:20%" class="text-center">API Type/Report Type</th>
                            <th style="width:16%" class="text-center">API/報表名稱</th>
                            <th style="width:12%" class="text-center">最新更新日期</th>
                            <th style="width:26%" class="text-center">備註</th>
                            <th style="width:8%" class="text-center">編輯</th>
                            <th style="width:6%" class="text-center">狀態</th>
                            <th style="width:12%" class="text-center">覆核生效日期</th>
                        </tr>
                    </thead>
                    <tbody v-if="reportList.length">
                        <tr v-for="(report, i) in reportList" :key="`report-data-${i}`">
                          <td :key="`td1-${i}`" class="text-center">{{report.report}}</td>
                          <td :key="`td2-${i}`">{{report.report_name}}</td>
                          <td :key="`td3-${i}`" class="text-center">{{report.updatetimestamp}}</td>
                          <td :key="`td4-${i}`">{{report.memo}}</td>
                          <td :key="`td5-${i}`" class="text-center">
                            <button type="button" class="btn btn-primary btn-sm" @click="openReportSettingPage(report.report)">
                              編輯
                            </button>
                          </td>
                          <td :key="`td6-${i}`">{{ report.status==='0' ? "未生效" : "已生效" }}</td>
                          <td :key="`td7-${i}`" class="text-center">{{report.checktimestamp}}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="7">
                                <h4 class="mb-3">查無資料</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <div style="height:30px"></div>
        </div>
        <div v-else>
            <Message
            class="mt-5 d-flex justify-content-center"
            loading
            message="資料讀取中，請稍候..."
            />
        </div>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import { getReportList } from "@/service";


export default {
  name: "CoverageReportList",
  components: {
    Message,
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      reportList: [],
    };
  },
  watch: {
    reload(val) {
      if (val) {
        this.getData();
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await getReportList(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          this.reportList = result.data;
        } else {
          this.reportList = [];
        }
        this.isLoading = false;
      });
    },
    /** 打開編輯保障設定 */
    openReportSettingPage(report) {
      this.$router.push({ name: 'ReportSetting', params: {report: report} })
    },
  },
};
</script>

